module.exports = "/static/media/mfa.4c1af60e.jpg";